// import React from "react";

// function AboutSection() {
//   return (
//     <div className="bg-primary-color py-12">
//       <div className="max-w-4xl mx-auto px-4">
//         <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-gray-800 mb-6">
//           About BrandFlow
//         </h2>
//         <p className="text-lg md:text-xl lg:text-2xl text-gray-800 leading-relaxed text-justify">
//           Brandflow is a vibrant company committed to helping startups and
//           businesses with creative branding, marketing, and growth solutions. We
//           recognize the problems of new businesses and aim to offer tailored
//           strategies that help them succeed in competitive markets. From
//           developing effective brand identities to implementing innovative
//           marketing campaigns, we assist businesses in standing out and
//           attaining sustainable growth. <br></br>
//           <br></br>Our company is comprised of technology, finance, human
//           resource, and strategy experts who work together to provide holistic
//           services that cater to the specific requirements of each client. We
//           are proud of our people-centric and collaborative culture that
//           guarantees that every business will receive personalized care and
//           solutions that will produce tangible outcomes.
//           <br></br>
//           <br></br>Creativity and strategy blend at Brandflow as we mesh
//           innovative concepts with real-world applications to bring visions to
//           life. Whether it is creating a brand that is memorable, expanding
//           operations, or expanding market presence, we are with businesses every
//           step of the way. <br></br>
//           <br></br>We don't merely build brands — we build success stories that
//           last. Let Brandflow be your partner in innovation and growth!
//         </p>
//       </div>
//     </div>
//   );
// }

// export default AboutSection;

import React from "react";

function AboutSection() {
  return (
    <div className="relative bg-primary-color py-20 overflow-hidden">
      {/* Soft background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#ffffff05] to-transparent pointer-events-none"></div>

      {/* Floating blurred orb */}
      <div className="absolute -top-20 -left-32 w-96 h-96 bg-secondary-color rounded-full blur-[140px]"></div>
      <div className="absolute -bottom-20 -right-32 w-96 h-96 bg-secondary-color rounded-full blur-[140px]"></div>

      <div className="max-w-5xl mx-auto px-6 relative z-10 animate-fade-in">
        {/* Section Title */}
        {/* <h2 className="text-4xl sm:text-5xl md:text-6xl font-semibold text-center text-highlight-color drop-shadow-lg mb-10 tracking-tight">
          About BrandFlow
        </h2> */}

        {/* Glassmorphic Content Box */}
        <div className="backdrop-blur-xl bg-secondary-color/35 border border-white/10 rounded-3xl p-8 md:p-10 shadow-2xl">
          <p className="text-base sm:text-lg md:text-xl text-white/80 leading-relaxed text-justify">
            BrandFlow is a vibrant company committed to helping startups and
            businesses with creative branding, marketing, and growth solutions.
            We recognize the challenges of new businesses and craft tailored
            strategies that help them thrive in competitive markets.
            <br />
            <br />
            From developing strong brand identities to implementing strategic
            marketing campaigns, we ensure every business gains a powerful and
            sustainable presence.
            <br />
            <br />
            Our team consists of technology, finance, human resource, and
            strategy experts who work together to deliver holistic solutions. We
            value a people-centric and collaborative culture, ensuring each
            business receives personalized care leading to measurable outcomes.
            <br />
            <br />
            At BrandFlow, creativity meets strategy — blending innovative ideas
            with real-world execution to bring visions to life. Whether it’s
            brand creation, scaling operations, or expanding market influence,
            we walk with businesses at every step.
            <br />
            <br />
            We don’t just help brands grow — we build lasting success stories.
            Let BrandFlow be your partner in innovation and long-term growth.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutSection;
